import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useEffect, useMemo } from 'react';
import { themeGet, Box, ActionList, Text } from '@primer/react';
import { LTTextInput } from '../LTInputBox/index.js';
import styled from 'styled-components';

var ListItemSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  word-break: break-all;\n  ", "\n"], ["\n  color: ", ";\n  word-break: break-all;\n  ", "\n"])), themeGet("colors.text.default"), function (_a) {
  var wrapListText = _a.wrapListText;
  return !wrapListText && "\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  ";
});
var ListItemSubSpan = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 12px;\n  color: ", ";\n"], ["\n  font-size: 12px;\n  color: ", ";\n"])), themeGet("colors.text.muted"));
var StyledBox = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  gap: ", ";\n  align-items: center;\n  padding: ", " ", ";\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  gap: ", ";\n  align-items: center;\n  padding: ", " ", ";\n"])), themeGet("space.1"), themeGet("space.1"), themeGet("space.1"));
var LTActionListV2 = function LTActionListV2(props) {
  var _a = props.leadingHeaderComponent,
    leadingHeaderComponent = _a === void 0 ? null : _a,
    _b = props.list,
    list = _b === void 0 ? [] : _b,
    searchBarRef = props.searchBarRef,
    _c = props.searchPlaceholder,
    searchPlaceholder = _c === void 0 ? "Search" : _c,
    _d = props.title,
    title = _d === void 0 ? "" : _d,
    _e = props.withSearch,
    withSearch = _e === void 0 ? false : _e,
    _f = props.wrapListText,
    wrapListText = _f === void 0 ? false : _f,
    rest = __rest(props, ["leadingHeaderComponent", "list", "searchBarRef", "searchPlaceholder", "title", "withSearch", "wrapListText"]);
  var _g = useState(""),
    searchValue = _g[0],
    setSearchValue = _g[1];
  var _h = useState(list),
    filteredOptions = _h[0],
    setFilteredOptions = _h[1];
  useEffect(function () {
    var elements = document.getElementsByClassName("actionListGroup-".concat(title || "noTitle"));
    for (var i = 0; i < elements.length; i++) {
      if (elements.length > 0 && elements[i].children.length > 0) {
        // remove attrributes to make the title visible to screen readers
        // default behaviour is to hide the title from screen readers and announce the group
        elements[i].children[0].removeAttribute("aria-hidden");
        elements[i].children[0].removeAttribute("role");
      }
    }
    setTimeout(function () {
      var elems = document.getElementsByClassName("sentinel");
      for (var i = 0; i < (elems === null || elems === void 0 ? void 0 : elems.length); i++) {
        elems[i].setAttribute("tabindex", "-1");
      }
    }, 0);
  }, []);
  useEffect(function () {
    if (searchValue) {
      var filteredOptions_1 = list.filter(function (option) {
        var _a, _b;
        return (_b = (_a = option.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchValue.toLowerCase());
      });
      setFilteredOptions(filteredOptions_1);
    } else {
      setFilteredOptions(list);
    }
  }, [list, searchValue]);
  var ActionListGroupWrapper = useMemo(function () {
    return function (_a) {
      var children = _a.children;
      var shouldRenderGroup = title || withSearch;
      return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRenderGroup && /*#__PURE__*/React.createElement(ActionList.Group, {
        className: "actionListGroup-".concat(title || "noTitle"),
        sx: {
          "& > div": {
            borderBottom: "1px solid",
            borderColor: "border.default",
            paddingTop: "0",
            paddingLeft: themeGet("space.2"),
            paddingRight: themeGet("space.2"),
            marginBottom: themeGet("space.2")
          },
          "& > ul": {
            overflowY: "auto",
            maxHeight: "330px",
            padding: "2px 0"
          }
        },
        // @ts-ignore: Title expects string but we are passing Box
        title: /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StyledBox, null, leadingHeaderComponent, /*#__PURE__*/React.createElement(Text, {
          color: "fg.default",
          role: "heading",
          "aria-level": 2,
          fontSize: 14
        }, title)), withSearch && /*#__PURE__*/React.createElement(LTTextInput, {
          onChange: function onChange(text) {
            setSearchValue(text);
          },
          placeholder: "".concat(searchPlaceholder || "Search ".concat((title === null || title === void 0 ? void 0 : title.toLowerCase()) || "")),
          value: searchValue,
          trailingAction: function trailingAction() {
            return setSearchValue("");
          },
          extraStyle: {
            margin: "4px 0"
          },
          forwardRef: searchBarRef
        }))
      }, children), !shouldRenderGroup && children);
    };
  }, [title, withSearch, searchPlaceholder]);
  return /*#__PURE__*/React.createElement(ActionList
  // role="menu" /* TODO: validate */
  , __assign({}, rest), /*#__PURE__*/React.createElement(ActionListGroupWrapper, null, filteredOptions.map(function (option, index) {
    if (!option) {
      return null;
    }
    var label = option.label,
      value = option.value,
      subText = option.subText,
      trailingVisual = option.trailingVisual,
      rest = __rest(option, ["label", "value", "subText", "trailingVisual"]);
    var _id = "selectItem-".concat(label.replace(/ /g, ""), "-").concat(index);
    return /*#__PURE__*/React.createElement(ActionList.Item, __assign({
      "aria-labelledby": _id,
      id: value,
      key: "".concat(label, "-").concat(index),
      sx: __assign(__assign({}, trailingVisual && {
        // dom updates when trailingVisual is present
        "& > div > div > span": {
          display: "flex",
          flexDirection: "column"
        }
      }), !trailingVisual && {
        "& > div > span": {
          display: "flex",
          flexDirection: "column"
        }
      })
    }, rest), /*#__PURE__*/React.createElement(ListItemSpan, {
      id: _id,
      wrapListText: wrapListText
    }, label), subText && /*#__PURE__*/React.createElement(ListItemSubSpan, null, " ", subText, " "), trailingVisual && /*#__PURE__*/React.createElement(ActionList.TrailingVisual, null, trailingVisual));
  })));
};
var templateObject_1, templateObject_2, templateObject_3;

export { LTActionListV2 as default };
